document.addEventListener("DOMContentLoaded", function () {
    let a = document.querySelectorAll('[bss-b2b-btn-quickview]')
    if (a.length) {
        a.forEach(element => {
           element.addEventListener('click', ()=>{
               setTimeout(() => {
                
                document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`)) 
               }, 1000);
           })   
        });
    }



   let quickAddDrawer = document.querySelector('#ProductGridContainer')
    if (quickAddDrawer) {
        let observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(m) {
                if (m.addedNodes.length) {
                    BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
                }
            });
        });
        observer.observe(quickAddDrawer, {
            childList: true
        });
    }
});